import Usluga from "~/cabinet/ts/data/usluga/Usluga";
import {USLUGA_ID_RECEIVESMS} from "~/cabinet/ts/Constant";

const ReceiveSms: Usluga = Usluga.new({
    id: USLUGA_ID_RECEIVESMS,
    dealer: {
        config: {}
    },
    client: {}
});

export default ReceiveSms;
